import { AllCommitmentPlans } from '@/components/investors-page/investorDetailsPage/tabs/pacingTab/allCommitmentPlansPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const AllCommitmentPlansPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>All Commitment Plans</title>
      </Head>
      <AllCommitmentPlans />
    </>
  );
};

export default AllCommitmentPlansPage;
